import {
  LinkCategory,
  LinkLabelCategory,
} from 'src/containers/ProjectDiagram/constants/categories';
import { ModelConceptRelationshipLabel } from 'src/containers/ProjectDiagram/types/data';
import { CreateRelationshipLabelOverrideOptions } from 'src/containers/ProjectDiagram/types/modelConceptRelationship';
import { getModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';

type CreateModelConceptRelationshipLabelOptions = {
  value: string;
} & CreateRelationshipLabelOverrideOptions;

export const getModelConceptRelationshipLabelKey = ({
  fromIri,
  value,
  toIri,
}: {
  fromIri?: string;
  value: string;
  toIri?: string;
}) =>
  `${LinkLabelCategory.MODEL_CONCEPT_RELATIONSHIP_LABEL}-${fromIri}-${value}-${toIri}`;

export const getLabelKeyFromRelationshipKey = (linkKey: string) =>
  linkKey.replace(
    new RegExp(`^${LinkCategory.MODEL_CONCEPT_RELATIONSHIP}`),
    LinkLabelCategory.MODEL_CONCEPT_RELATIONSHIP_LABEL
  );

export const createModelConceptRelationshipLabel = ({
  fromIri,
  value,
  toIri,
  keyOverride,
}: CreateModelConceptRelationshipLabelOptions): ModelConceptRelationshipLabel => ({
  key:
    keyOverride ||
    getModelConceptRelationshipLabelKey({ fromIri, value, toIri }),
  from: fromIri ? getModelConceptClassKey(fromIri) : undefined,
  value,
  to: toIri ? getModelConceptClassKey(toIri) : undefined,
  category: LinkLabelCategory.MODEL_CONCEPT_RELATIONSHIP_LABEL,
});
